<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to previous page" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="finance" pageId="loan-payments-other-employee" color="white"></help-link>
                    <v-btn v-if="hasEditRights" fab dark small color="primary" title="Create Loan Payments for any employee" @click="showAdd">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-card class="elavation-1" style="margin-top:5px;"> 
                <v-toolbar flat height="45px">
                    <div class="wp-30 mb-10">
                        <v-text-field v-model="search" append-icon="search" label="Search name, loan type, status" single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="loans_summary_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr style="cursor:pointer;" @click="viewDetails(props.item)" title="Click to view payment schedule">
                            <td>
                                <v-chip @click="viewUserProfile(props.item, $store.state.userId)" style="margin:-5px 0px 0px -5px;">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.name}} 
                                </v-chip>
                            </td>
                            <td>{{ props.item.loanType }}</td>
                            <td>
                                <span v-if="props.item.paymentSchedule.length">{{ props.item.paymentStartDate | moment('MMM DD, YYYY') }}</span>
                            </td>
                            <td>
                                <span v-if="props.item.paymentSchedule.length">{{ props.item.lastPaymentDate | moment('MMM DD, YYYY') }}</span>
                            </td>
                            <td>PHP {{ numFormat.formatNumber(props.item.totalDue) }}</td>
                            <td>PHP {{ numFormat.formatNumber(getTotalPaid(props.item.paymentSchedule)) }}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>
        </v-flex>

        <v-dialog v-model="dialogLoans" width="700" persistent>   
            <add-edit-loan ref="loansRef" :dialogLoans.sync="dialogLoans" @send="addHandler"></add-edit-loan>
        </v-dialog>
    </v-layout> 
</template>

<script>

import commonfn from '@/common/functions'
import loansApi from '@/api/loans'
import numFormat from '@/common/num_format'
import pageKeys from '@/common/pagekeys'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'Loans',
    metaInfo: {
        title: 'Loan Payments',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, create Loan Payments' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'add-edit-loan': () => import('@/components/Loans/AddEditLoans')
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)
        
        return {
            commonfn, //for refactor
            numFormat,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            search: userPrefs.getSearchKeyword(routeName),
            error: false,
            errorMessage: '',
            loading: false,
            headers: [
                {text: 'Employee',align: 'left',value: 'name', width: '15%', sortable:true},
                {text: 'Loan Type',align: 'left',value: 'loanType', width: '15%', sortable:true},
                {text: 'Payment Start Date',align: 'left',value: 'paymentStartDate',  width: '10%', sortable:true},
                {text: 'Last Payment Date',align: 'left',value: 'lastPaymentDate',  width: '10%', sortable:true},
                {text: 'Total Amount to Pay',align: 'left',value: 'totalDue',  width: '10%', sortable:true},
                {text: 'Total Amount Paid',align: 'left',value: 'paymentSchedule',  width: '10%', sortable:true},
                {text: 'Status',align: 'left',value: 'status',  width: '10%', sortable:true},
            ],
            dialogLoans: false,
            loans: []
        }
    },
    methods: {
        showAdd(){
            const data = {
                isRequestForOtherUser: true,
                pageKey: pageKeys.loans
            }
            this.$refs.loansRef.setAdd(data)
            this.dialogLoans = true
        },
        getTotalPaid(data){
            var paidSchedule = data.filter(x => {
                return x.paidOn != null && x.status == commonfn.getStatusCode('Paid')
            })
            if (paidSchedule.length>0) return paidSchedule.map(x => x.amountDue).reduce((prev,next) => prev+next)
            else return 0
        },
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId) this.$router.push(`/myprofile`)
            else this.$router.push(`/hr/employees/${data.userId}`)
        },
        viewDetails(data) {
            if (data.userId == this.$store.state.userId) {
                this.$router.push(`/finance/myloans/${data.loanId}`)
            }else{
                this.$router.push(`/finance/loans/${data.loanId}`)
            }
        },
        addHandler(loanId){
            this.$router.push(`/finance/loans/${loanId}`)
        },
        async getSummary(show_loading) {
            try {
                this.loading = show_loading
                const response = await loansApi.getSummary()
                if (response.status == 200) {
                    this.loans = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Loan Payments'
        })

        this.getSummary(true)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            userPrefs.updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        loans_summary_filtered() {
            var temp = this.loans
            if (this.search) {
                temp = temp.filter(item => {
                    return (
                            item.name.toLowerCase().includes(this.search.toLowerCase()) ||
                            item.loanType.toLowerCase().includes(this.search.toLowerCase()) ||
                            commonfn.getStatusDescription(item.status).toLowerCase().includes(this.search.toLowerCase()) 
                        )
                })
            }

            // Add computed fields
            temp = temp.map(e => {
                const hasSchedule = Array.isArray(e.paymentSchedule) && e.paymentSchedule.length > 0;
                const paymentStartDate = hasSchedule ? e.paymentSchedule[0].dueOn : null;
                const lastPaymentDate = hasSchedule ? e.paymentSchedule[e.paymentSchedule.length - 1].dueOn : null;

                return {
                    ...e,
                    paymentStartDate,
                    lastPaymentDate,
                    Status: e.paidOn ? 'Paid' : 'Unpaid'
                }
            })
            return temp
        },
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path)
        },
    }
}
</script>
<style scoped>